import { useId, type ReactNode } from "react";

export interface PaidFeatureGateProps {
  allowed: boolean;
  title: string;
  preview: ReactNode;
  upgradeAction: ReactNode;
  children: ReactNode;
}
export interface PaidFeatureAccess {
  allowed: boolean;
  upgradeAction: ReactNode;
}
export function PaidFeatureGate({ allowed, title, preview, upgradeAction, children }: PaidFeatureGateProps) {
  const titleId = useId();
  if (allowed) return <>{children}</>;
  return (
    <section aria-labelledby={titleId} className="relative isolate grid overflow-hidden rounded-lg border bg-card text-card-foreground">
      <div inert aria-hidden="true" className="col-start-1 row-start-1 pointer-events-none select-none opacity-30 blur-[2px]">{preview}</div>
      <div className="col-start-1 row-start-1 z-10 flex items-center justify-center bg-background/70 p-4">
        <div className="max-w-sm space-y-3 text-center">
          <svg aria-hidden="true" className="mx-auto size-6 text-muted-foreground" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="4" y="10" width="16" height="11" rx="2" /><path d="M8 10V6a4 4 0 0 1 8 0v4" /></svg>
          <p id={titleId} className="font-medium">{title}</p>
          <p className="text-sm text-muted-foreground">Доступно на платном тарифе и в пробном периоде.</p>
          {upgradeAction}
        </div>
      </div>
    </section>
  );
}
